// extracted by mini-css-extract-plugin
module.exports = {"breakpointMedium":"500px","breakpointLarge":"790px","breakpointSticky":"500px"};